(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/vehicleMap/vehicleMapWidget.tpl.html',
    '<div id="vehicleMapWidget"><div ng-if="!isWidgetPostInitFinished || isWidgetPreInitFinished === false"><loading-animation></loading-animation></div><div ng-if="mapUrl.indexOf(\'404.html\') > -1"><no-data-available></no-data-available></div><div ng-show="isWidgetPostInitFinished && isDataAvailable === false"><no-authorize></no-authorize></div></div><div ng-if="!(mapUrl.indexOf(\'404.html\') > -1)" class="row" style="min-height: 100px"><div class="col-sm-12 col-md-12"><div><iframe id="vehicleMap" ng-onload="vehicleMapLoadEvent()" ng-src="{{mapUrl | trustAsResourceUrl}}" style="height : {{height}}px; width : 100%;border: 0; overflow: hidden;"></iframe></div></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleMap/vehicleMapWidget.tpl.js